import {component} from '../form/Constant'

export const dischargeKey = {
    dischargeInformation: 'Discharge Information',
    diagnosis: 'diagnosis',
    clinicalNarrative: 'clinicalNarrative',
    investigations: 'investigations',
    procedures: 'procedures',
    socialHistory: 'socialHistory',
    medicationChanges: 'medicationChanges',
    allergies: 'allergies',
    futurePlans: 'futurePlans',
    informationGivenToPatient: 'informationGivenToPatient',
    informationGivenToGP: 'informationGivenToGP',
}
export const dischargeList = [
    {
        key: dischargeKey.dischargeInformation,
        description: '',
        children: [
            {
                key: dischargeKey.diagnosis,
                component: component.inputTextArea,
                placeholder: 'Input here',

                defaultValue: '',
            },
            {
                key: dischargeKey.clinicalNarrative,
                component: component.inputTextArea,

                placeholder: 'Input here',
                defaultValue: '',
            },
            {
                key: dischargeKey.investigations,
                component: component.inputTextArea,
                placeholder: 'Input here',
                defaultValue: '',
            },
            {
                key: dischargeKey.procedures,
                component: component.inputTextArea,

                placeholder: 'Input here',
                defaultValue: '',
            },
            {
                key: dischargeKey.socialHistory,
                component: component.inputTextArea,
                placeholder: 'Input here',

                defaultValue: '',
            },
            {
                key: dischargeKey.medicationChanges,
                component: component.inputTextArea,

                placeholder: 'Input here',
                defaultValue: '',
            },
            {
                key: dischargeKey.allergies,
                component: component.inputTextArea,
                placeholder: 'Input here',

                defaultValue: '',
            },
            {
                key: dischargeKey.futurePlans,
                component: component.inputTextArea,

                placeholder: 'Input here',
                defaultValue: '',
            },
            {
                key: dischargeKey.informationGivenToPatient,
                component: component.inputTextArea,
                placeholder: 'Input here',

                defaultValue: '',
            },
            {
                key: dischargeKey.informationGivenToGP,
                component: component.inputTextArea,
                placeholder: 'Input here',
                defaultValue: '',
            },
        ],
    },
]

export const hcpDetailList = [
    {
        key: dischargeKey.dischargeInformation,
        description: (
            <div>
                <p className="mb-2">
                    Fill in the following information to create an account
                </p>
                <p>
                    <i>
                        Note: The account will be sent to the patient via email
                        after completing the form
                    </i>
                </p>
            </div>
        ),
        children: [
            {
                key: dischargeKey.diagnosis,
                component: component.inputText,
                placeholder: 'Auto-generated if leaving blank',

                defaultValue: '',
            },
            {
                key: dischargeKey.clinicalNarrative,
                component: component.inputTextArea,

                placeholder: 'Field is required',
                defaultValue: '',
            },
            {
                key: dischargeKey.investigations,
                component: component.inputText,
                placeholder: 'Auto-generated if leaving blank',
                defaultValue: '',
            },
        ],
    },
]
